export const STATUS_META: Record<
  string,
  { color: string; label: (b: any) => string }
> = {
  active: { color: "green", label: () => "Active" },
  reminder: {
    color: "gold",
    label: (b) => `Due in ${b.days_until_due} day(s) – Reminder`,
  },
  overdue: {
    color: "red",
    label: (b) => `Overdue by ${Math.abs(b.days_until_due)} day(s)`,
  },
  paid: { color: "blue", label: () => "Paid for this cycle" },
  terminated: { color: "volcano", label: () => "Terminated" },
};

export const fmt = (v: number) =>
  (Number(v) || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
